var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{class:['search-bar__results',_vm.showResults ? 'search-bar__results--show':''],attrs:{"name":"result-animation","tag":"ul"}},_vm._l((_vm.resultList),function(token){return _c('SearchBarResultsItem',{key:token.id,attrs:{"token":token},on:{"click":function($event){return _vm.addSelectedToken(token)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }